import React from "react";
import {
  SearchAddDiv,
  SearchBox,
  SearchContainer,
  SearchIconDiv,
} from "../Volunteer/Volunteer.style";
import SearchIcon from "@mui/icons-material/Search";
import AddModal from "../modal/AddModal";

const VolunteerFilterNoAdd = ({ filter, setFilter }) => {
  return (
    <>
      <SearchAddDiv>
        <SearchContainer>
          <SearchIconDiv>
            <SearchIcon />
          </SearchIconDiv>
          <SearchBox
            value={filter || ""}
            onChange={(e) => setFilter(e.target.value)}
            placeholder="Search ...."
            maxLength={50}
          />
        </SearchContainer>
        <div style={{}}></div>
      </SearchAddDiv>
      <AddModal></AddModal>
    </>
  );
};

export default VolunteerFilterNoAdd;
